import axios from "axios";
import { API_URL } from "@config/Endpoints";

export const customAxios = axios.create({
  baseURL: API_URL,
  headers: {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
});
